<template>
  <div v-if="isProductFruitsListVisible">
    <v-card
      outlined
      class="px-0 mt-4 d-flex flex-column"
    >
      <v-card-text class="px-0">
        <div
          id="checklist"
          :class="{'small-checklist': loading}"
          class="checklist"
        >
          <div v-if="!loading" />
          <div
            v-else
            class="w-full d-flex justify-space-around"
          >
            <v-progress-circular
              indeterminate
              :size="50"
              :width="5"
              color="primary"
            />
          </div>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>

import { showSnackbarMessage } from '@/lib/snackbarMessages'
import { productFruits } from 'product-fruits'

export default {
  data () {
    return {
      loading: true,
      hasChecklist: true
    }
  },
  computed: {
    isProductFruitsListVisible () {
      return this.hasChecklist
    }
  },
  mounted () {
    productFruits.safeExec(() => {
      this.setupChecklist()
    })
  },
  methods: {
    setupChecklist () {
      this.injectChecklistToElement()
      this.listenToListChanges()
    },
    injectChecklistToElement () {
      const checklistId = process.env.VUE_APP_PRODUCT_FRUITS_CHECKLIST_CODE_FIRST_STEPS
      const el = document.getElementById('checklist')
      try {
        // eslint-disable-next-line
        window.productFruits.api.checklists.injectToElement(checklistId, el)
      } catch (e) {
        this.hasChecklist = false
      }
      this.loading = false
    },
    listenToListChanges () {
      const checklists = window.productFruits.api.checklists
      checklists.listen('dismissed', this.handleDismissedEvent)
      checklists.listen('completed', this.handleCompletedEvent)
    },

    handleDismissedEvent () {
      showSnackbarMessage('info', this.$t('alerts.product-fruits.info'))
      this.hasChecklist = false
    },

    handleCompletedEvent () {
      showSnackbarMessage('info', this.$t('alerts.product-fruits.success'))
      this.hasChecklist = false
    }
  }
}
</script>

<style scoped>
  .checklist {
    height: 450px;
    overflow-y: auto;
  }
  .small-checklist {
    height: 100px;
  }
</style>
